/* global ajax_object */

// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/foundation.js'; import './autoload/products-filter.js'; // eslint-disable-line

// Import local dependencies
import './plugins/lazyload';
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
//import '@fancyapps/fancybox/dist/jquery.fancybox.min';
// import { jarallax, jarallaxElement } from 'jarallax';
import ScrollOut from 'scroll-out';
import { smoothScroll } from './plugins/smoothScroll';

/**
 * Import scripts from Custom Divi blocks
 */
// eslint-disable-next-line import/no-unresolved
//;

/**
 * Import scripts from Custom Elementor widgets
 */
// eslint-disable-next-line import/no-unresolved
//;

/**
 * Import scripts from Custom ACF Gutenberg blocks
 */
// eslint-disable-next-line import/no-unresolved
import '../blocks/gutenberg/acf-box-hover-link-block/index.js'; import '../blocks/gutenberg/acf-contacts-block/index.js'; import '../blocks/gutenberg/acf-example-block/index.js'; import '../blocks/gutenberg/acf-filter-grid/index.js'; import '../blocks/gutenberg/acf-hero-block/index.js'; import '../blocks/gutenberg/acf-icon-repeater-block/index.js'; import '../blocks/gutenberg/acf-image-gallery-block/index.js'; import '../blocks/gutenberg/acf-image-text-link-block/index.js'; import '../blocks/gutenberg/acf-lookbooks/index.js'; import '../blocks/gutenberg/acf-products-with-filter-block/index.js'; import '../blocks/gutenberg/acf-solutions-grid-block/index.js'; import '../blocks/gutenberg/acf-success-slider-block/index.js'; import '../blocks/gutenberg/acf-text-video-block/index.js';

/**
 * Init foundation
 */
$(document).foundation();

const setHeaderHeightVar = () => {
  const adminBar = document.querySelector('#wpadminbar');
  const adminBarHeight =
    adminBar && window.innerWidth > 600 ? adminBar.clientHeight : 0;

  document.documentElement.style.setProperty(
    '--admin-bar-offset',
    `${adminBarHeight}px`
  );

  const header = document.querySelector('header.header');
  const headerHeight = header?.clientHeight || 0;

  document.documentElement.style.setProperty(
    '--header-offset',
    `${adminBarHeight + headerHeight}px`
  );
};

const smoothAnchorScroll = () => {
  document.querySelectorAll('a[href^="#"]').forEach((anchor) => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();

      const targetId = this.getAttribute('href').substring(1);
      const target = document.getElementById(targetId);

      if (target) {
        const headerOffset =
          parseInt(
            getComputedStyle(document.documentElement).getPropertyValue(
              '--header-offset'
            ),
            10
          ) || 0;

        const elementPosition =
          target.getBoundingClientRect().top + window.scrollY;
        const offsetPosition = elementPosition - headerOffset;

        smoothScroll(offsetPosition, { duration: 1500 });
      }
    });
  });
};

const smoothUrlHashScroll = () => {
  const hash = window.location.hash;

  if (hash) {
    const target = document.getElementById(hash.substring(1));

    if (target) {
      const headerOffset =
        parseInt(
          getComputedStyle(document.documentElement).getPropertyValue(
            '--header-offset'
          ),
          10
        ) || 0;

      const elementPosition =
        target.getBoundingClientRect().top + window.scrollY;
      const offsetPosition = elementPosition - headerOffset;

      smoothScroll(offsetPosition, { duration: 1500 });
    }
  }
};

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function () {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function () {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

/**
 * Scripts which runs after DOM load
 */
$(document).on('ready', function () {
  /**
   * Make elements equal height
   */
  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  /**
   * Add fancybox to images
   */
  // $('.gallery-item')
  //   .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
  //   .attr('rel', 'gallery')
  //   .attr('data-fancybox', 'gallery');
  // $(
  //   '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]'
  // ).fancybox({
  //   minHeight: 0,
  //   helpers: {
  //     overlay: {
  //       locked: false,
  //     },
  //   },
  // });

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Detect element appearance in viewport
   */
  ScrollOut({
    // offset: function () {
    //   return window.innerHeight - 100;
    // },
    once: true,
    onShown: function (element) {
      if ($(element).is('.ease-order')) {
        $(element)
          .find('.ease-order__item')
          .each(function (i) {
            let $this = $(this);
            $(this).attr('data-scroll', '');
            window.setTimeout(function () {
              $this.attr('data-scroll', 'in');
            }, 300 * i);
          });
      }
    },
  });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function (event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function () {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    }
  );

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  $(window)
    .on('toggled.zf.responsiveToggle', function () {
      $('.menu-icon').toggleClass('is-active');
    })
    .on('changed.zf.mediaquery', function () {
      $('.menu-icon').removeClass('is-active');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function () {
    setTimeout(function () {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });

  resizeVideo();

  $('.dropdown-toggle').on('click', function () {
    $(this).parent('.dropdown-filter').toggleClass('open');
  });

  $(document).on('click', function (e) {
    if (!$(e.target).closest('.dropdown-filter').length) {
      $('.dropdown-filter').removeClass('open');
    }
  });
});

$(document).on('change', 'input[name="tags[]"]', function () {
  let $label = $(this).closest('label');
  if ($(this).is(':checked')) {
    $label.addClass('checked');
  } else {
    $label.removeClass('checked');
  }
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function () {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }

  setHeaderHeightVar();
  smoothAnchorScroll();
  smoothUrlHashScroll();
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function () {
  // jQuery code goes here

  setHeaderHeightVar();
  resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function () {
  // jQuery code goes here
});

jQuery(document).ready(function ($) {
  function load_blog_posts(paged = 1) {
    let categories = [];
    let tags = [];

    $('input[name="categories[]"]:checked').each(function () {
      categories.push($(this).val());
    });
    $('input[name="tags[]"]:checked').each(function () {
      tags.push($(this).val());
    });

    $.ajax({
      url: ajax_object.ajax_url,
      type: 'POST',
      data: {
        action: 'filter_blog_posts',
        categories: categories,
        tags: tags,
        paged: paged,
        nonce: ajax_object.nonce,
        archive: ajax_object.archive,
      },
      beforeSend: function () {
        $('.posts-list-wrapper').addClass('loading');
      },
      success: function (response) {
        $('.posts-list-wrapper').html(response);
      },
      error: function (xhr, status, error) {
        console.error('Blog posts loading error:', status, error); // eslint-disable no-console
      },
      complete: function () {
        $('.posts-list-wrapper').removeClass('loading');
      },
    });
  }

  load_blog_posts(1);

  $('#blog-filter input').on('change', function () {
    load_blog_posts(1);
  });

  $(document).on('click', '.ajax-pagination a', function (e) {
    e.preventDefault();
    let page = $(this).attr('href').split('paged=')[1];
    if (!page) page = 1;
    load_blog_posts(page);
  });
});
